// extracted by mini-css-extract-plugin
module.exports = {"Error":"InlineErrorFallback_Error__Igg4b","Logo":"InlineErrorFallback_Logo___DpaS","Header":"InlineErrorFallback_Header__aJQGJ","Message":"InlineErrorFallback_Message__I2vHJ"};